import {useDispatch} from 'react-redux';
import * as React from 'react';
import {useNavigation} from '@react-navigation/native';
import {useSelector} from 'react-redux';
import {getNewsById} from '../../redux/actions/news';
import {newsByIdSelector} from '../../redux/selectors/news';
import View from './view';
import {Props} from './model';
import {Screens} from '../../shared/routing';
import {newsSlice} from '../../redux/reducers/news';

export const NewsArticleScreen = ({route}: Props) => {
  const news = useSelector(newsByIdSelector);
  const navigation = useNavigation();
  const dispatch = useDispatch();

  React.useEffect(() => {
    const id = +route.params.id;

    if (!Number.isInteger(id)) {
      navigation.navigate(Screens.News);
      return;
    }

    if (news && id === news?.current?.id) {
      return;
    }

    (async () => {
      try {
        newsSlice.actions.setNewsById(null);
        await dispatch(getNewsById(id));
      } catch (error) {
        if (error.status === 404) {
          navigation.navigate(Screens.News);
        } else {
          throw error;
        }
      }
    })();
  }, [route.params.id, news, news?.current?.id]);

  return View({loading: !news, prevNews: news?.previous, currentNews: news?.current, nextNews: news?.next});
};
